import { j as i, c as o } from "./utils-BdNIfrGQ.js";
import { c as m } from "./index-Di82Y7n3.js";
import { t as p } from "./BaseTypography.styles-D7he6cFf.js";
import { n as d } from "./normalize-spacing-DY0KSpr_.js";
const g = m("", {
  variants: {
    type: {
      default: "text-md",
      subtitle: "text-lg font-semibold leading-snug",
      lead: "text-xl font-semibold leading-snug",
      helper: "text-sm text-muted-foreground leading-normal",
      small: "text-sm leading-normal",
      inline: "inline-flex"
    }
  },
  defaultVariants: {
    type: "default"
  }
}), y = ({
  align: t = "left",
  modifier: a = "pretty",
  truncate: e,
  type: n,
  spacing: r,
  children: l,
  ...s
}) => /* @__PURE__ */ i.jsx(
  "p",
  {
    className: o(
      p({ align: t, modifier: a, truncate: e }),
      "leading-normal",
      g({ type: n }),
      d(r)
    ),
    ...s,
    children: l
  }
);
export {
  y as P
};
